module.exports = __webpack_public_path__ + "static/img/qbz03_svd.a500123.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/qbz03_svd.png
// module id = PSQN
// module chunks = 0